import React, { Component } from 'react'
import Backdrop from '../styles/Backdrop'
import UploadFileStyle from '../styles/UploadFileStyle'
import ErrorDialog from '../components/ErrorDialog'
import { connect } from 'react-redux'
//import 'core-js/fn/symbol/iterator.js'
import Button from '@material-ui/core/Button'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogUlStyle from '../styles/DialogUlStyle'

class UploadFile extends Component {
  state = { value: '', visible: false }
  inputRef = React.createRef()

  nieobslugiwanaStruktura() {
    return this.props.error.includes('Nieznane sprawozdanie')
  }

  getErrorContent() {
    if (this.nieobslugiwanaStruktura())
      return (
        <DialogContent>
          <DialogContentText>
            Przykro nam, ale nie potrafimy otworzyć Twojego pliku XML.
          </DialogContentText>
          <br />
          <DialogContentText>
            Wskazany plik zawiera e-Sprawozdanie w strukturze nie obsługiwanej
            <br />
            w bieżącej wersji programu. Obecnie potrafimy obsłużyć następujące
            <br />
            struktury e-Sprawozdań:
          </DialogContentText>
          <DialogUlStyle>
            <li>
              <DialogContentText>jednostka inna, w złotych</DialogContentText>
            </li>
            <li>
              <DialogContentText>jednostka mała, w złotych</DialogContentText>
            </li>
            <li>
              <DialogContentText>jednostka mikro, w złotych</DialogContentText>
            </li>
            <li>
              <DialogContentText>
                organizacja pozarządowa, w złotych
              </DialogContentText>
            </li>
          </DialogUlStyle>
        </DialogContent>
      )
    return (
      <DialogContent>
        <DialogContentText>
          Przykro nam, ale nie potrafimy otworzyć Twojego pliku XML.
        </DialogContentText>
        <br />
        <DialogContentText>
          Prawdopodobnie wskazany plik nie zawiera sprawozdania finansowego{' '}
          <br />w formacie zgodnym z opublikowanymi strukturami e-Sprawozdań.
        </DialogContentText>
      </DialogContent>
    )
  }

  handleUpload = e => {
    const [file] = e.target.files
    this.setState({ value: '' })
    this.props.onUpload(file)
  }

  handleSetBackdrop = () => {
    this.setState({ visible: true })
    window.addEventListener('focus', this.handleFocus)
    window.document.addEventListener('mousemove', this.handleFocus)
  }

  handleFocus = () => {
    this.setState({ visible: false })
    window.removeEventListener('focus', this.handleFocus)
    window.document.removeEventListener('mousemove', this.handleFocus)
  }

  render() {
    const {
      state: { value, visible },
      props: { label, variant, filter, isErrorDialog },
      handleUpload,
      handleSetBackdrop,
    } = this
    return (
      <UploadFileStyle>
        <div>
          <Button
            onClick={() => this.inputRef.current.click()}
            color="primary"
            variant={variant || 'contained'}
          >
            {label}
          </Button>
          <input
            ref={this.inputRef}
            accept={filter}
            id="upload"
            type="file"
            name="nazwapliku"
            placeholder="Dodaj plik"
            value={value}
            onChange={e => handleUpload(e)}
            onClick={handleSetBackdrop}
            required
          />
        </div>
        {visible && <Backdrop />}
        {isErrorDialog && (
          <ErrorDialog
            title={'Problem z otwarciem pliku'}
            content={this.getErrorContent()}
            error={this.props.error}
            onCloseDialog={this.props.onCloseErrorDialog}
          />
        )}
      </UploadFileStyle>
    )
  }
}

const mapStateToProps = state => {
  return {
    error: state.sprawozdanie.err,
  }
}

export default connect(
  mapStateToProps,
  null,
)(UploadFile)
